// extracted by mini-css-extract-plugin
module.exports = {"className":"textHeadingS_className__EcBLZ"};